import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

export interface SortEvent {
    column: string;
    direction: SortDirection;
}

@Directive({
    selector: '[cwrSortableColumn]',
})
export class SortableColumnDirective {
    @Input() cwrCfsortable!: string;
    @Input() sortableEnabled = true;
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();

    @HostBinding('class.asc') get isAscending() {
        return this.sortableEnabled && this.direction === 'asc';
    }
    @HostBinding('class.desc') get isDescending() {
        return this.sortableEnabled && this.direction === 'desc';
    }
    @HostListener('click') rotate() {
        if (!this.sortableEnabled) {
            return;
        }
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.cwrCfsortable, direction: this.direction });
    }
}
